import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/getmypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changePicture = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/changepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const clientSearchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/clientsearchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const clientGetPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/clientgetpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const analyzeVehicleLicensePicture = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/analyzevehiclelicensepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfo/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

